import React, { Fragment } from 'react';
import { Button, Clearfix, Col, ControlLabel, Grid, Row } from 'react-bootstrap';
import * as consts from '../../const.js';
import { PARTICIPANT_STATUS } from '../../constants/consentStatus';
import SubjectService from '../subject/subject.service';
import { Time } from 'tc-client-common';
import { path } from 'ramda';

class ParticipantDetailsComponent extends React.Component {
  constructor(props) {
    super(props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let oldParticipantJourney = this.props.participantJourney;
    let newParticipantJourney = nextProps.participantJourney;
    //if component was rendered before for same participant, this means component was re-rendered because an update happened
    //and if the update was caused by a status change
    if (
      oldParticipantJourney !== null &&
      newParticipantJourney !== null &&
      oldParticipantJourney.id === newParticipantJourney.id
    ) {
      let oldParticipantStatus = oldParticipantJourney.overallStatus;
      let newParticipantStatus = newParticipantJourney.overallStatus;

      //we check old status was inactive and the new status is active
      let inactiveStatusesArray = [
        'ABORTED',
        'WITHDRAWN_CONSENT',
        'STUDY_COMPLETED',
        'STUDY_TERMINATED',
        'FAILED_SCREENING'
      ];
      let oldStatusWasInactive = inactiveStatusesArray.includes(oldParticipantStatus);
      let newStatusIsActive = !inactiveStatusesArray.includes(newParticipantStatus);
      //if the condition is true, we check participant for new consent versions and open information modal
      if (oldStatusWasInactive && newStatusIsActive) {
        this.props.checkParticipantHasNewVersions(
          oldParticipantJourney.gid,
          this.getLastConsentingGid(this.props.documents.items)
        );
      }
    }
  }

  getLastConsentingGid = (documents) => {
    for (let i = documents.length - 1; i >= 0; i--) {
      if (documents[i].consentingGid !== null) {
        return documents[i].consentingGid;
      }
    }
    return null;
  };

  getStudySubjectNumber = (props) => {
    const isSSNGenerated = ((props.participantStudy || {}).studyConfiguration || {}).generatedSubjectNumber;
    const studySubjectNumber = props.participantJourney ? props.participantJourney.subjectNumber || '-' : '';
    if (isSSNGenerated) {
      return <p id="subject-number">{studySubjectNumber}</p>;
    }
    return (
      <Button id="subject-number" bsStyle="link" onClick={() => props.openDetailsModal()}>
        {studySubjectNumber} <i className="material-icons md-18">mode_edit</i>
      </Button>
    );
  };

  getGender = (participantData) => {
    const gender = path(['gender'], participantData);
    if (gender) {
      return (
        <Fragment>
          <ControlLabel htmlFor="gender">{consts.GENDER}</ControlLabel>
          <Clearfix />
          <Button id="gender" bsStyle="link" onClick={() => this.props.openGenderModal()}>
            {consts.GENDER_NAME[gender] || '-'}
            <i className="material-icons md-18">mode_edit</i>
          </Button>
        </Fragment>
      );
    }
  };

  getBirthDate = (participantData) => {
    const birthDate = path(['birthDate'], participantData);
    if (birthDate) {
      return (
        <Fragment>
          <ControlLabel htmlFor="birthdate">{consts.BIRTHDATE}</ControlLabel>
          <Button id="birthdate" bsStyle="link" onClick={() => this.props.openBirthDateModal()}>
            <Time timestamp={birthDate} format={'ddd, MMM DD, YYYY'} />
            <i className="material-icons md-18">mode_edit</i>
          </Button>
        </Fragment>
      );
    }
  };

  getAddress = (participantData, element) => {
    const address = path([element], participantData);
    if (address) {
      const labelForAddress = this.getAddressLabel(element);
      return (
        <Fragment>
          <ControlLabel htmlFor={element}>{labelForAddress}</ControlLabel>
          <Clearfix />
          <Button id={element} bsStyle="link" onClick={() => this.props.openAddressModal()}>
            {address}
            <i className="material-icons md-18">mode_edit</i>
          </Button>
        </Fragment>
      );
    }
  };

  getAddressLabel = (item) => {
    switch (item) {
      case 'addressCity':
        return consts.ADDRESS_CITY;
      case 'addressPostalCode':
        return consts.ADDRESS_POSTAL_CODE;
      case 'addressStreet':
        return consts.ADDRESS_STREET;
      default:
        return item;
    }
  };

  render() {
    let sites = SubjectService.getSiteNames(this.props.participantSites);
    const participantData = path(['subjectPhi', 'subjectInfo', 'data', 'participant'], this.props);

    return (
      !this.props.isFetchingJourney && (
        <Grid fluid id="participant-details">
          <Row>
            <Col xs={2}>
              <ControlLabel htmlFor="participant-status">{consts.PARTICIPANT_STATUS}</ControlLabel>
              <Clearfix />
              <Button id="participant-status" bsStyle="link" onClick={() => this.props.openStatusModal()}>
                {this.props.participantJourney ? PARTICIPANT_STATUS[this.props.participantJourney.overallStatus] : ''}
                <i className="material-icons md-18">mode_edit</i>
              </Button>
            </Col>
            <Col xs={2}>
              <ControlLabel htmlFor="trialconsent-id">{consts.PARTICIPANT_ID}</ControlLabel>
              <p id="trialconsent-id">{this.props.participantJourney ? this.props.participantJourney.userId : ''}</p>
            </Col>
            <Col xs={4}>
              <ControlLabel htmlFor="study-name">{consts.STUDY_NAME}</ControlLabel>
              <p id="study-name">{this.props.participantStudy ? this.props.participantStudy.name : ''}</p>
            </Col>
            <Col xs={2}>
              <ControlLabel htmlFor="protocol-no">{consts.STUDY_PROTOCOL_NO}</ControlLabel>
              <p id="protocol-no">{this.props.participantStudy ? this.props.participantStudy.protocolNumber : ''}</p>
            </Col>
            <Col xs={2}>
              <ControlLabel htmlFor="sites">{consts.SITE_NAME}</ControlLabel>
              <p id="sites">{sites}</p>
            </Col>
          </Row>
          <Row>
            <Col xs={2}>
              <ControlLabel htmlFor="subject-number">{consts.STUDY_SUBJECT_NUMBER}</ControlLabel>
              <Clearfix />
              {this.getStudySubjectNumber(this.props)}
            </Col>
            <Col xs={2}>
              <ControlLabel htmlFor="participant-username">{consts.PARTICIPANT_USERNAME}</ControlLabel>
              <p id="participant-username">
                {this.props.participantJourney ? this.props.participantJourney.participantUsername : ''}
              </p>
            </Col>
            <div className={participantData ? 'show' : 'hide'}>
              <Col xs={2}>
                <ControlLabel htmlFor="first-name">{consts.FIRST_NAME}</ControlLabel>
                <p id="first-name">{path(['firstName'], participantData) || ''}</p>
              </Col>
              <Col xs={2}>
                <ControlLabel htmlFor="last-name">{consts.LAST_NAME}</ControlLabel>
                <p id="last-name">{path(['lastName'], participantData) || ''}</p>
              </Col>
              <Col xs={2}>{this.getGender(participantData)}</Col>
              <Col xs={2}>{this.getBirthDate(participantData)}</Col>
            </div>
          </Row>
          <Row>
            <Col xs={2}>
              <ControlLabel htmlFor="participant-email">{consts.PARTICIPANT_NOTIFICATION_EMAIL}</ControlLabel>
              <Clearfix />
              <Button id="participant-email" bsStyle="link" onClick={() => this.props.openParticipantEmailModal()}>
                {this.props.participantJourney
                  ? this.props.participantJourney.emailUpdatedOn
                    ? consts.PARTICIPANT_EMAIL['PROVIDED']
                    : consts.PARTICIPANT_EMAIL['NOT_PROVIDED']
                  : ''}
                <i className="material-icons md-18">mode_edit</i>
              </Button>
            </Col>
            <div className={participantData ? 'show' : 'hide'}>
              <Col xs={2}>{this.getAddress(participantData, 'addressCity')}</Col>
              <Col xs={2}>{this.getAddress(participantData, 'addressPostalCode')}</Col>
              <Col xs={6}>{this.getAddress(participantData, 'addressStreet')}</Col>
            </div>
          </Row>
        </Grid>
      )
    );
  }
}

export default ParticipantDetailsComponent;
